import React from 'react';
import styled from 'styled-components';
import { string, func, number, any, bool } from 'prop-types';
import { CircleSlash } from 'styled_components/SVG/CircleSlash';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const Toggle = styled.div`
	display: flex;
	width: 56px;
	height: 20px;
	box-shadow: -2px -2px 2px ${props => props.theme.white} inset,
		1.5px 1.5px 3px ${props => props.theme.boxShadow} inset;
	border-radius: 3px;
	align-items: center;
	justify-content: space-between;
	position: relative;
	background-color: ${props => props.theme.Cool_Gray_Light_3};
	overflow: visible;
	&.toggle-slider-2 {
		.icon-selection-1::after {
			border-right: none;
		}
		.icon-selection-0 {
			svg {
				margin-left: 3px;
			}
		}
	}
	#circle-slash {
		width: 14px;
		height: 14px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		width: 72px;
		height: 24px;
		box-shadow: -2px -2px 2px ${props => props.theme.white} inset,
			1.5px 1.5px 2px ${props => props.theme.boxShadow} inset;
		label::after {
			left: 11px !important;
			height: 14px !important;
		}
		.slider {
			width: 32px !important;
			height: 24px !important;
			box-shadow: -2.5px -2.5px 5px ${props => props.theme.white},
				2.5px 2.5px 5px ${props => props.theme.boxShadow};
		}
		.icon-selection-0,
		.icon-selection-1,
		.icon-selection-2,
		.icon-selection-3 {
			width: 32px !important;
			height: 24px !important;
		}

		svg {
			width: 16px;
			height: 24px;
		}
		&.toggle-slider-2 {
			#tab-1:checked ~ .slider {
				-webkit-transform: translateX(40px);
				transform: translateX(40px);
			}
			.icon-selection-1 {
				svg {
					margin-left: 2px;
				}
			}
			.icon-selection-0 {
				svg {
					margin-left: 3px;
				}
			}
		}
		&.toggle-slider-3 {
			width: 112px !important;
			#tab-1:checked ~ .slider {
				-webkit-transform: translateX(40px) !important;
				transform: translateX(40px) !important;
			}
			#tab-2:checked ~ .slider {
				-webkit-transform: translateX(80px);
				transform: translateX(80px);
			}
		}
		&.toggle-slider-4 {
			width: 152px;
			#tab-1:checked ~ .slider {
				-webkit-transform: translateX(40px);
				transform: translateX(40px);
			}
			#tab-2:checked ~ .slider {
				-webkit-transform: translateX(80px);
				transform: translateX(80px);
			}
			#tab-3:checked ~ .slider {
				-webkit-transform: translateX(120px);
				transform: translateX(120px);
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 104px;
		height: 32px;
		box-shadow: -2px -2px 3px ${props => props.theme.white} inset,
			2px 2px 3px ${props => props.theme.boxShadow} inset;
		label::after {
			left: 17px !important;
			height: 18px !important;
		}
		.slider {
			width: 48px !important;
			height: 32px !important;
			box-shadow: -2.5px -2.5px 5px ${props => props.theme.white},
				2.5px 2.5px 5px ${props => props.theme.boxShadow};
		}
		svg {
			width: 20px;
			height: 32px;
		}
		&.toggle-slider-2 {
			#tab-1:checked ~ .slider {
				-webkit-transform: translateX(56px);
				transform: translateX(56px);
			}
		}
		&.toggle-slider-3 {
			width: 160px !important;
			#tab-1:checked ~ .slider {
				-webkit-transform: translateX(56px) !important;
				transform: translateX(56px) !important;
			}
			#tab-2:checked ~ .slider {
				-webkit-transform: translateX(112px);
				transform: translateX(112px);
			}
		}
		&.toggle-slider-4 {
			width: 216px;

			#tab-1:checked ~ .slider {
				-webkit-transform: translateX(56px);
				transform: translateX(56px);
			}
			#tab-2:checked ~ .slider {
				-webkit-transform: translateX(112px);
				transform: translateX(112px);
			}
			#tab-3:checked ~ .slider {
				-webkit-transform: translateX(168px);
				transform: translateX(168px);
			}
		}
		.icon-selection-0,
		.icon-selection-1,
		.icon-selection-2,
		.icon-selection-3 {
			width: 48px !important;
			height: 32px !important;
		}
	}

	&.toggle-slider-3 {
		width: 88px;

		.icon-selection-2::after {
			border-right: none;
		}

		#tab-1:checked ~ .slider {
			-webkit-transform: translateX(32px);
			transform: translateX(32px);
			-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
				-webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		}
	}
	&.toggle-slider-4 {
		width: 120px;

		.icon-selection-3::after {
			border-right: none;
		}
		#tab-1:checked ~ .slider {
			-webkit-transform: translateX(31px);
			transform: translateX(31px);
			-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
				-webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		}

		#tab-2:checked ~ .slider {
			-webkit-transform: translateX(62px);
			transform: translateX(62px);
			-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
			transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
				-webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		}
	}
	input {
		display: none;
	}

	label {
		margin-bottom: 0px;
	}
	input:checked + label {
		-webkit-transition: all 0.5s ease;
		transition: all 0.5s ease;
		//color: #6d5dfc;
	}

	.icon-selection-0,
	.icon-selection-1,
	.icon-selection-2,
	.icon-selection-3 {
		width: 24px;
		height: 20px;
		display: flex;
		justify-content: center;
		border-radius: 3px;
		align-items: center;
		cursor: pointer;
		-webkit-transition: all 0.5s ease;
		transition: all 0.5s ease;
		#circle-slash {
			display: none;
		}
		:hover {
			&.false {
				svg:first-child {
					opacity: 0;
				}
				#circle-slash {
					display: flex;
				}
			}
		}
		&.active {
			.line {
				fill: url(#line-selector-1-swipe-gradient);
			}
			.pie-2 {
				fill: url(#pie-selector-2-swipe-gradient);
			}
			.pie-3 {
				fill: url(#pie-selector-3-swipe-gradient);
			}
			.bar {
				fill: url(#bar-selector-1-swipe-gradient);
			}
			.bar-2 {
				fill: url(#bar-selector-2-swipe-gradient);
			}
			.bar-3 {
				fill: url(#bar-selector-3-swipe-gradient);
			}
			.daily {
				fill: url(#daily-selector-1-swipe-gradient);
			}
			.hourly {
				fill: url(#hourly-selector-1-swipe-gradient);
			}
			.monthly {
				fill: url(#monthly-selector-1-swipe-gradient);
			}
			.daily-2 {
				fill: url(#daily-selector-2-swipe-gradient);
			}
			.trend {
				fill: url(#trend-selector-1-swipe-gradient);
			}
		}
	}

	.icon-selection-0:hover,
	.icon-selection-1:hover,
	.icon-selection-2:hover,
	.icon-selection-3:hover {
		.line,
		.bar,
		.daily,
		.hourly,
		.monthly,
		.trend {
			fill: ${props => handleColorType(props.module, props.theme)};
		}
		&.active {
			.line {
				fill: url(#line-selector-1-swipe-gradient);
			}
			.bar {
				fill: url(#bar-selector-1-swipe-gradient);
			}
			.daily {
				fill: url(#daily-selector-1-swipe-gradient);
			}
			.trend {
				fill: url(#trend-selector-1-swipe-gradient);
			}
			.hourly {
				fill: url(#hourly-selector-1-swipe-gradient);
			}
			.monthly {
				fill: url(#monthly-selector-1-swipe-gradient);
			}
		}
	}

	label::after {
		border-right: 1px solid ${props => props.theme.Cool_Gray_Med_1};
		content: '';
		display: block;
		left: 8px;
		width: 1px;
		height: 12px;
		position: relative;
	}

	.slider {
		position: absolute;
		width: 24px;
		height: 20px;
		border-radius: 3px;
		box-shadow: -1.3px -1.3px 2.5px ${props => props.theme.white},
			2px 2px 4px ${props => props.theme.boxShadow};
		pointer-events: none;
		background-color: ${props => handleColorType(props.module, props.theme)};
		z-index: 10;
	}

	svg {
		z-index: 1000;
	}

	#tab-0:checked ~ .slider {
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
		-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
			-webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	}

	#tab-1:checked ~ .slider {
		-webkit-transform: translateX(31px);
		transform: translateX(31px);
		-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
			-webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	}

	#tab-2:checked ~ .slider {
		-webkit-transform: translateX(64px);
		transform: translateX(64px);
		-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
			-webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	}
	#tab-3:checked ~ .slider {
		-webkit-transform: translateX(95px);
		transform: translateX(95px);
		-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
			-webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	}
`;

function onClickEvent(onClick, id, svgId, checkSlider, selected) {
	const element = document.getElementById(id);
	if (checkSlider) {
		checkSlider(element);
	}
	const oldElement1 = document.querySelector('.icon-selection-0.active');
	const oldElement2 = document.querySelector('.icon-selection-1.active');
	const oldElement3 = document.querySelector('.icon-selection-2.active');
	if (oldElement1) {
		oldElement1.classList.remove('active');
	}
	if (oldElement2) {
		oldElement2.classList.remove('active');
	}
	if (oldElement3) {
		oldElement3.classList.remove('active');
	}
	if (element) {
		element.classList.add('active');
	}
	if (document.getElementById(`${svgId}trans1`)) {
		document.getElementById(`${svgId}trans1`).beginElement();
	}

	if (onClick) {
		onClick(selected);
	}
}

export const ToggleButton = ({
	className,
	id,
	onClick,
	cypressId,
	enabled,
	module,
	children,
	groupName,
	checkSlider,
}) => {
	const enable = enabled ? '' : ' disabled';

	const toggleSliderLength = children && children?.length;
	return (
		<Toggle
			id={`${id}`}
			className={`${className} ${enable}  ${module} toggle-slider-${toggleSliderLength}`}
			//onClick={enabled ? () => onClickEvent(onClick, id) : undefined}
			//onMouseOver={onMouseOver}
			data-cy={cypressId}
			module={module}
		>
			{/* {children}
			{!enabled && <CircleSlash module={module} className={screen} />} */}

			{React.Children.map(children || null, (child, key) => {
				if (
					key === 0 &&
					!document.getElementById(child.props.id) &&
					child.props.enabled !== 'false'
				) {
					setTimeout(() => {
						onClickEvent(onClick, `icon-selection-${key}`, child.props.id);
					}, 1000);
				}

				return (
					<>
						<input
							type='radio'
							name={groupName}
							value=''
							id={`tab-${key}`}
							disabled={child.props.enabled !== 'false' ? false : true}
						/>
						<label
							for={`tab-${key}`}
							className={
								key === 0
									? `icon-selection-${key} active ${child.props.enabled}`
									: `icon-selection-${key} ${child.props.enabled}`
							}
							id={`icon-selection-${key}`}
							onClick={
								child.props.enabled !== 'false'
									? () =>
											onClickEvent(
												child.props.onClick,
												`icon-selection-${key}`,
												child.props.id,
												checkSlider,
												child.props.value,
											)
									: () => {}
							}
						>
							<child.type {...child.props} key={`-child`} />
							<CircleSlash module={module} className={''} />
						</label>
					</>
				);
			})}

			<div class='slider'></div>
		</Toggle>
	);
};

ToggleButton.propTypes = {
	className: string,
	id: string,
	onClick: func,
	cypressId: string,
	enabled: bool,
	breakpoint: number,
	module: string,
	children: any,
	groupName: string,
	checkSlider: func,
};

ToggleButton.defaultProps = {
	className: '',
	id: '',
	onClick: () => {},
	cypressId: '',
	enabled: true,
	breakpoint: 900,
	module: 'support',
	children: null,
	groupName: 'default-group-name',
	checkSlider: () => {},
};
